import module from 'kendu/legacy/module'
import { forEach } from 'lodash'

export class ApiService {
  constructor ($localStorage) {
    this.$localStorage = $localStorage
  }

  link (url, params) {
    let query = []

    forEach(params, (value, key) => {
      if (Array.isArray(value)) {
        value.forEach((item) => (query.push(key + '[]=' + item)))
      } else if (typeof value !== 'undefined') {
        query.push(key + '=' + value)
      }
    })

    if (this.$localStorage.token) query.push(`&TOKEN=${this.$localStorage.token}`)

    return url + '?' + query.join('&')
  }
}

module.service('$api', ApiService)



// WEBPACK FOOTER //
// ./src/deprecated/services/$api.js